import axios from 'axios';
import {req, reqJson} from './axiosFun';

/**
 * 佣金管理
 **/
// 佣金管理-获取列表
export const commissionList = (params) => { return reqJson("post", "/api/business/commission/list?pageNum="+params.pageNum+"&pageSize="+params.pageSize, params) };
// 佣金管理-保存（添加）
export const commissionSave = (params) => { return reqJson("post", "/api/business/commission/add", params) };
// 佣金管理-保存（编辑）
export const commissionEdit = (params) => { return reqJson("put", "/api/business/commission/edit", params) };
// 佣金管理-删除
export const commissionDelete = (params) => { return req("delete","/api/business/commission/deleteById",params)};

//订单佣金-列表
export const orderCommissionList = (params) =>{return reqJson("post","/api/business/orderCommission/list?pageNum="+params.pageNum+"&pageSize="+params.pageSize, params) };
//订单状态调整
export const orderCommissionBatchStatusChange = (params) =>{return reqJson("post","/api/business/orderCommission/batchStatusChange", params) };



// WEBPACK FOOTER //
// ./src/api/commissionMg.js